// 搜索用退货状态
const SEARCH_REFUND_STATUS = [
    { label: "全部", value: "" },
    { label: "退款成功", value: "SUCCESS" },
    { label: "退款异常", value: "CHANGE" },
    { label: "退款待处理", value: "WAIT_REFUND" },
    { label: "退款关闭", value: "REFUNDCLOSE" }
];

export const commerceGoodsReturnOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    labelWidth: '120',
    /* defaultSort: {
        prop: 'refundTime',
        order: 'descending'
    }, */
    column: [
        {
            label: "退货单编号",
            prop: "refundNumber",
            type: "input",
            width: "180",
            search: true,
            searchPlaceholder: "退货单编号",
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "订单编号",
            prop: "orderNumber",
            type: "input",
            width: "180",
            search: true,
            searchPlaceholder: "订单编号",
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货状态",
            prop: "status",
            type: "select",
            search: true,
            searchPlaceholder: "退货状态",
            dicData: SEARCH_REFUND_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "商品名称",
            prop: "goodsName",
            type: "input",
            search: true,
            searchPlaceholder: "商品名称",
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "商品规格",
            prop: "goodsSpec",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货数量",
            prop: "refundCount",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货金额(元)",
            prop: "refundAmount",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货时间",
            prop: "refundTime",
            type: "datetime",
            sortable: true,
            width: "120",
            format: "yyyy-MM-dd",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货人姓名",
            prop: "refundUserName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货人电话",
            prop: "refundUserPhone",
            type: "input",
            search: true,
            searchPlaceholder: "退货人电话",
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退回推广佣金",
            prop: "refundPromoteAmount",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退回上级推广佣金",
            prop: "refundParentPromoteAmount",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货开始时间",
            prop: "startTime",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            format: "yyyy-MM-dd",
            search: true,
            searchPlaceholder: "退货开始时间",
            hide: true,
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "退货结束时间",
            prop: "endTime",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            format: "yyyy-MM-dd",
            search: true,
            searchPlaceholder: "退货结束时间",
            hide: true,
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "支付开始时间",
            prop: "orderStartTime",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            format: "yyyy-MM-dd",
            search: true,
            searchPlaceholder: "支付开始时间",
            hide: true,
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "支付结束时间",
            prop: "orderEndTime",
            type: "date",
            valueFormat: "yyyy-MM-dd",
            format: "yyyy-MM-dd",
            search: true,
            searchPlaceholder: "支付结束时间",
            hide: true,
            clearable: true,
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};
